import React, { useState } from "react";
import Logo from "../dist/images/tc-logo-horizontal.png";
import { Link } from "react-router-dom";
import { MenuData } from "./MenuData";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../service/ApiClient";
import "../styles/font-awesome-4.7.0/css/font-awesome.min.css";
import "../styles/Navbar.css";
import { getToken } from "../service/AuthService";

function Navbar() {
  const [openLinks, setOpenLinks] = useState(false);
  const [clicked, setClicked] = useState(false);
  const navigate = useNavigate();

  // Check if token exists to determine if user is logged in
  const token = getToken();
  const isLoggedIn = token !== null && token !== undefined && token !== "undefined";

  const handleClick = () => {
    setClicked(!clicked);
  };

  const toggleNavbar = () => {
    setOpenLinks(!openLinks);
  };

  async function handleLogout() {
    try {
      const rawUser = sessionStorage.getItem("user");
      const token = sessionStorage.getItem("token");
      const loginTs = sessionStorage.getItem("login_ts");
      console.log("From navbar logout");

      if (rawUser && loginTs) {
        const user = JSON.parse(rawUser);
        await apiClient.post(
          "manageusercredits",
          {
            action: "logSessionEnd",
            organization: user.organization,
            username: user.username,
            log_ts: loginTs,
            logout_ts: new Date().toISOString(),
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
    } catch (e) {
      console.warn("logSessionEnd failed:", e);
    } finally {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("login_ts");
      window.location.assign("/login");
    }
  }

  return (
    <nav className="navbar" id="navbar">
      <div className="logo">
        <Link to="/">
          <img src={Logo} alt="Brand Logo" />
        </Link>
      </div>

      <div className="menu-icons" onClick={handleClick}>
        <i className={clicked ? "fa fa-times" : "fa fa-bars"}></i>
      </div>

      <ul className={clicked ? "nav-menu active font-medium" : "nav-menu font-medium"}>
        {MenuData.map((item, index) => {
          const title = item.title.toLowerCase();
          if (title === "sign up" && isLoggedIn) return null; // hide "Sign up" if logged in
          if (title === "logout" && !isLoggedIn) return null; // show "Logout" only if logged in

          return (
            <li key={index}>
              <a
                href={item.url}
                className={item.cName}
                onClick={(e) => {
                  if (item.title === "LOGOUT") {
                    e.preventDefault();
                    handleLogout(e);
                 }
                }}
              >
                <i className={item.icon}></i> {item.title}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default Navbar;
